module.exports = __webpack_public_path__ + "img/_ivory.e737c58b.jpg";